import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import { getBackrsToken } from '../utils/tokenHelpers';

/**
 * Fetch base query with auth
 */
export const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASEURL}`,
  prepareHeaders: (headers) => {
    const accessToken = getBackrsToken();

    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }

    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');

    return headers;
  },
});

/**
 * Fetch base query for Lubav endpoints
 */
export const lubavAppBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_LUBAV_API_BASEURL}`,
  prepareHeaders: (headers) => {
    const accessToken = getBackrsToken();

    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }

    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');

    return headers;
  },
});
